import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';


function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}

const benefits = [
  { number: 1, title: "Secure Digital Records", description: "Personal identification and health information are encrypted for maximum protection.", image: require("../../src/assets/images/website/Datasecurity.jpg") },
  { number: 2, title: "Instant Discharge Summaries", description: "Automated discharge summaries are generated after each consultation, simplifying record management.", image: require("../../src/assets/images/website/product9.png") },
  { number: 3, title: "Comprehensive Consultation Records", description: "Capture prescriptions, vitals, diagnosis details, physician comments, and referrals in a single, easily accessible digital record.", image: require("../../src/assets/images/website/product3.png") },
  { number: 6, title: "Seamless Integration of Old Medical Records", description: "Effortlessly incorporate past medical records for a complete patient history.", image: require("../../src/assets/images/website/product4.png") },
  { number: 5, title: "Robust Data Encryption", description: "Ensure patient data security with industry-standard encryption, meeting all compliance requirements.", image: require("../../src/assets/images/website/product5.png") },
  { number: 4, title: "Complete Patient History at Your Fingertips", description: "Access a holistic view of patient health, enabling informed and effective treatment decisions.", image: require("../../src/assets/images/website/product6.png") }
];
const appointmentFeatures = [ // Changed 'benefits' to 'appointmentFeatures'
  { image: require("../../src/assets/images/website/klinicq1.png"), title: "Smart Appointment Flow", description: "Reduce waiting times with optimized scheduling and a token-based system." },
  { image: require("../../src/assets/images/website/klinicq2.png"), title: "Automated Patient Queue", description: "Intelligent queue management ensures seamless patient flow and minimal delays." },
  { image: require("../../src/assets/images/website/klinicq3.png"), title: "Flexible Booking Options", description: "Choose between walk-in tokens or scheduled time slots based on convenience." },
  { image: require("../../src/assets/images/website/klinicq5.png"), title: "Effortless Remote Consultations", description: "Teleconsultation support allows patients to access care from anywhere." },
  { image: require("../../src/assets/images/website/klinicq1.png"), title: "Patient-First Scheduling", description: "Empower patients with personalized time slots and physician availability." },
  { image: require("../../src/assets/images/website/klinicq2.png"), title: "Integrated Appointment Management", description: "Streamline booking and tracking directly within the EMR system." }
];
class BenifitsHospital extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            hoveredImage: null,
      
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };
    handleMouseEnter = (index) => {
      this.setState({ hoveredIndex: index });
    };
  
    handleMouseLeave = () => {
      this.setState({ hoveredIndex: null });
    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        
        return (
            <div className="">

                <div className="">
                    {/* <section className="my-head"> */}
                        {/* <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div> */}
                    {/* </section> */}
                    <div className="">
                        {/* <div className="sidemenu ">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div> */}

                        {/* <section className="main-body hospital-profilegap "> */}
                            {/* <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            /> */}

                            {/* <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout} /> */}

                            {/* <div className="container-fluid checkout-tabs"> */}
                                {/* <IdleTimeOutModal
                                    showModal={this.state.showModal}
                                    handleClose={this.handleClose}
                                    handleLogout={this.handleLogout}
                                /> */}

                                {/* <IdleTimer
                                    ref={ref => { this.idleTimer = ref }}
                                    element={document}
                                    onActive={this.onActive}
                                    onIdle={this.onIdle}
                                    onAction={this.onAction}
                                    debounce={250}
                                    timeout={hospitaltimeout} /> */}

<div className='product-section'>
    <Headerweb/>
  
    
 
            <hr className='m-0' style={{ color: '#D9F4FF' }} />
            <section className='pt-5'>
           
            <div className='' id='increase_revenue' style={{ marginTop: '50px', position: 'relative' }}>
    <div className='background-image' style={{ backgroundImage: `url(${require("../../src/assets/images/website/240.jpg")})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '500px', position: 'relative' }}>
        <div className='overlay-text' style={{ position: 'absolute', left: '10%', top: '50%', transform: 'translateY(-50%)', color: '#fff' }}>
            <h1>Benefits For Hospital</h1>
            <p>Transforming Hospital Efficiency & Patient Experience</p>
        </div>
    </div>
</div>      {/* <div className=''>
                <div className='' id='increase_productivity' style={{ marginTop: '50px' }}>
    <div className='row m-0'>
        <div className='col-12'>
            <img src={require("../../src/assets/images/website/249.jpg")} className='w-100 h-auto' alt="Increase Productivity" />
        </div>
    </div>
</div>
</div> */}
<div className="row justify-content-center text-center mt-5">
    <h1>
      Our Commitment to <span className="balance-move">Hospital</span> Care Excellence
    </h1>
  </div>
 
      <div className="container-90" style={{ margin: "10px auto", maxWidth: "1200px", position: "relative" }}>
  <div className="timeline">
    
    {/* Center Image */}
    <div
      style={{
        width: "150px",
        height: "100%",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: "2",
      }}
    >
      <img 
        src={require("../../src/assets/images/website/thermometer.png")} // Replace with your actual image URL
        alt="Center Image"
        style={{ width: "100%", height: "100%" }} 
      />
    </div>

    {[...Array(10)].map((_, index) => (
      <div key={index} className="timeline-item mb-5 d-flex align-items-center" style={{ position: "relative" }}>
        
        {/* Left Content for Odd Sections */}
        {index % 2 === 0 && (
          <div
            style={{
              backgroundColor: "#f7f9fb",
              borderRadius: "5px",
              padding: "15px",
              width: "35%",
              textAlign: "left",
              boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.2)",
              position: "relative",
              boxShadow: "0px 0px 15px 4px rgba(0, 33, 71, 0.8)"
            }}
          >
            {/* Horizontal Connecting Line (Inside the Box) */}
            <div   
              style={{
                width: "40px",
                height: "2px",
                backgroundColor: "#002147",
                position: "absolute",
                right: "-40px", // Moves outside the box edge
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: "2",
              }}
            ></div>

            <h3
              style={{
                backgroundColor: "#002147",
                color: "#fff",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              {index + 1 === 1 && "Smart Scheduling, Reduced No-Shows"}
              {index + 1 === 3 && "Streamlined Check-In & Check-Out"}
              {index + 1 === 5 && "Effective Resource Utilization"}
              {index + 1 === 7 && "Effortless Staff Scheduling"}
              {index + 1 === 9 && "Digitalized Billing & Payments"}
            </h3>
            <p style={{ marginTop: "10px", color: "#000" }}>
              {index + 1 === 1 &&
                "Implement appointment scheduling and token systems tailored to your hospital's needs, with automated reminders to minimize no-shows."}
              {index + 1 === 3 &&
                "Enhance patient flow with a simplified digital check-in and check-out process."}
              {index + 1 === 5 &&
                "Maximize your hospital's resources with data-driven insights and analytical reporting."}
              {index + 1 === 7 &&
                "Simplify physician and staff shift planning with our intuitive shift planner."}
              {index + 1 === 9 &&
                "Access insights and data to drive better decision-making."}
            </p>
          </div>
        )}

        {/* Temperature Circle - Left Side for Left-Aligned Content */}
        {index % 2 === 0 && (
          <div
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              border: "3px solid #002147",
              backgroundColor: "#fff",
              color: "#002147",
              textAlign: "center",
              lineHeight: "45px",
              fontWeight: "bold",
              position: "absolute",
              left: "38%",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: "3",
            }}
          >
            {index === 9 && "97.5°F"}  {/* Bottom (coldest) */}
            {index === 8 && "98.1°F"}
            {index === 7 && "98.3°F"}
            {index === 6 && "98.7°F"}
            {index === 5 && "99.2°F"}
            {index === 4 && "99.9°F"}
            {index === 3 && "100.1°F"}
            {index === 2 && "100.4°F"}
            {index === 1 && "101.2°F"}
            {index === 0 && "101.6°F"}  {/* Top (hottest) */}
          </div>
        )}

        {/* Right Content for Even Sections */}
        {index % 2 !== 0 && (
          <div
            style={{
              backgroundColor: "#f7f9fb",
              borderRadius: "5px",
              padding: "15px",
              width: "35%",
              textAlign: "left",
              marginLeft: "auto",
              boxShadow: "0px 0px 15px 4px rgba(0, 33, 71, 0.8)",
              position: "relative",
            }}
          >
            {/* Horizontal Connecting Line (Inside the Box) */}
            <div
              style={{
                width: "40px",
                height: "2px",
                backgroundColor: "#002147",
                position: "absolute",
                left: "-40px", // Moves outside the box edge
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: "2",
              }}
            ></div>

            <h3
              style={{
                backgroundColor: "#002147",
                color: "#fff",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              {index + 1 === 2 && "Secure Digital Identity"}
              {index + 1 === 4 && "Data Encryption & Protection"}
              {index + 1 === 6 && "Seamless Doctor-Patient Integration"}
              {index + 1 === 8 && "Analytical Insights for Informed Decisions"}
              {index + 1 === 10 && "Enhanced Communication & Automation"}
            </h3>
            <p style={{ marginTop: "10px", color: "#000" }}>
              {index + 1 === 2 &&
                "Ensure accurate physician and patient identification with secure digital profiles."}
              {index + 1 === 4 &&
                "Safeguard sensitive patient data with robust encryption and protection measures."}
              {index + 1 === 6 &&
                "Foster improved communication and collaboration between physicians and patients."}
              {index + 1 === 8 &&
                "Leverage powerful analytical insights to optimize hospital operations and improve patient care."}
              {index + 1 === 10 &&
                "Improve communication efficiency with automated reminders and notifications."}
            </p>
          </div>
        )}

        {/* Temperature Circle - Right Side for Right-Aligned Content */}
        {index % 2 !== 0 && (
          <div
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              border: "3px solid #002147",
              backgroundColor: "#fff",
              color: "#002147",
              textAlign: "center",
              lineHeight: "45px",
              fontWeight: "bold",
              position: "absolute",
              right: "38%",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: "3",
            }}
          >
            {index === 9 && "97.5°F"}  {/* Bottom */}
            {index === 8 && "98.1°F"}
            {index === 7 && "98.3°F"}
            {index === 6 && "98.7°F"}
            {index === 5 && "99.2°F"}
            {index === 4 && "99.9°F"}
            {index === 3 && "100.1°F"}
            {index === 2 && "100.4°F"}
            {index === 1 && "101.2°F"}
            {index === 0 && "101.6°F"}  {/* Top */}
          </div>
        )}
      </div>
    ))}
  </div>
</div>
<div className="row justify-content-center text-center">
<h1 className="text-center">Benefits of EMR</h1>              

  </div>
 
  <p className='text-center'>Unlock the Power of Digital Medical Records with KlinicQ</p>
<div className="flow-container">
        <div className="flow-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="flow-item">
              <div className="circle">{benefit.number}</div>
              <div
                className="flip-container"
                onMouseEnter={() => this.handleMouseEnter(index)}
                onMouseLeave={this.handleMouseLeave}
              >
                <div className={`flip-inner ${this.state.hoveredIndex === index ? "flipped" : ""}`}>
                  <div className="flip-front">
                    <h3>{benefit.title}</h3>
                    <p>{benefit.description}</p>
                  </div>
                  <div className="flip-back" style={{ backgroundImage: `url(${benefit.image})` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="row justify-content-center text-center">
<h1 className="text-center">Benefits of Appointment system</h1>

  </div>
      
<p className="text-center">Revolutionizing Appointments for Safety & Convenience</p>


      <div className="appointment-container">
        <div className="appointment-grid">
          {appointmentFeatures.map((feature, index) => ( 
            <div key={index} className="appointment-item">
              <img src={feature.image} alt={feature.title} className="appointment-image" />
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>


<div className="background-container">
                  <div className="custom-row">
                    {/* Left Column: Content */}
                    <div className="custom-col content-section">
                      <h1>Book Your Personalized Demo</h1>
                      <p>
                        Now explore how our advanced tools can revolutionize
                        Nucleo healthcare operations. Schedule a demo with our
                        team and unlock the full potential of innovation in
                        healthcare.
                      </p>
                      <a href="/Webcontact" className="book-demo-btn">
                        Book Demo
                      </a>
                    </div>

                    {/* Right Column: Image */}
                    <div className="custom-col image-section">
                      <img
                        src={require("../../src/assets/images/website/234.png")}
                        alt="Healthcare Innovation"
                      />
                    </div>
                  </div>
                </div>


              
            </section>
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
    componentDidMount = () => {
       /*  console.log(this.props.userdata.user_type);
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { }); */
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(BenifitsHospital);